import React, { useEffect } from 'react';
import { Button, Caption, Paragraph, Stack } from '@mediahuis/chameleon-react';
import { Trans, useTranslation } from 'react-i18next';
import { useQueryParams } from '../../hooks/useQueryParams';
import { EventActionValues, EventCategoryValues, EventLabelValues } from '../../types/tracking';
import { useTracking } from '../../hooks/useTracking';

const i18nKeys: { [key: string]: { [key: string]: string } } = {
  user_already_linked: {
    title: 'spotify.error.alreadyLinked.titleText',
    description: 'spotify.error.alreadyLinked.description',
    button: 'spotify.error.alreadyLinked.buttonText',
    traceId: 'spotify.error.traceId',
  },
  default: {
    title: 'spotify.error.default.titleText',
    description: 'spotify.error.default.description',
    traceId: 'spotify.error.traceId',
  },
};

function SpotifyError() {
  const { brand } = useQueryParams();
  const { traceId, error } = useQueryParams();
  const { t } = useTranslation();
  const { trackEventWithCategory } = useTracking();

  useEffect(() => {
    // On page load and brand/brandGroup present
    if (brand && error === 'user_already_linked')
      trackEventWithCategory(
        EventActionValues.Show,
        EventLabelValues.SpotifyAccountLinks,
        EventCategoryValues.AccountLinking,
        'bekijk-spotify-koppelingen',
        ''
      );
    // Only depending on brand because otherwise the useEffect would be triggered multiple times
    // and incomplete events would be tracked
  }, [brand]);

  const handleSpotifyRedirection = () => {
    if (brand && error === 'user_already_linked')
      trackEventWithCategory(
        EventActionValues.Click,
        EventLabelValues.SpotifyAccountLinksToOverview,
        EventCategoryValues.AccountLinking,
        'bekijk-spotify-koppelingen',
        ''
      );
    window.location.href = 'https://content-access.spotify.com/';
  };

  const keys = error ? i18nKeys[error] || i18nKeys.default : i18nKeys.default;

  return (
    <Stack alignItems="center" flexDirection="column" className="bundling-upgrade px-6 m-auto">
      <Paragraph size="Paragraph" className="bold text-center mt-7">
        <Trans i18nKey={keys.title} />
      </Paragraph>
      <Caption size="lg" className="text-center">
        <Trans i18nKey={keys.description} />
      </Caption>
      {error === 'user_already_linked' && (
        <Button
          size="lg"
          onClick={handleSpotifyRedirection}
          appearance="primary"
          data-cy="spotifyLinkButton"
          className="mb-3">
          {t(keys.button)}
        </Button>
      )}
      <Caption size="sm" className="text-center">
        <Trans i18nKey={keys.traceId} values={{ traceId }} />
      </Caption>
    </Stack>
  );
}

export default SpotifyError;
